import type { IDailyrentBannerConfig } from '../../types/dailyrentBannerConfig';

/**
 * Возвращает настройки баннера посуточной аренды, если фичетогл включён
 * и в RS лежит конфиг со списком статей. Иначе баннера нет ни в одной статье.
 */
export const getDailyrentBannerConfig = (
  isEnabled: boolean | null | undefined,
  config: IDailyrentBannerConfig | null | undefined,
): IDailyrentBannerConfig | undefined => {
  if (!isEnabled || !config || !Array.isArray(config.postIds)) {
    return undefined;
  }

  return config;
};

/**
 * Статья есть в списке статей баннера посуточной аренды.
 * Id сравниваются как числа: в RS их могут записать строками
 */
export const isDailyrentBannerArticle = (postId: number, config: IDailyrentBannerConfig | undefined): boolean =>
  Boolean(config?.postIds.some(id => Number(id) === postId));
